module.exports = __webpack_public_path__ + "static/media/charu.a4c2f229.jpeg";